/**
 * Kuryer (yetkazib beruvchi) kontraktlari.
 *
 * Oqim: uy-yetkazish buyurtmasi punkt operatori tasdiqlaydi → kuryerga biriktiradi
 * → kuryer xaritada mijoz lokatsiyasini ko'radi → "Oldim" (punktdan) → "Yetkazdim".
 * Kuryer telefoni davriy GPS yuboradi → EGASI real-time xaritada kuzatadi.
 * Marketplace jadvallar GLOBAL (RLS yo'q).
 */
import { z } from 'zod';
import { uuidSchema } from './common.schema.js';
// ─── Kuryer: o'z buyurtmalari ro'yxati ────────────────────────────
export const courierOrderQuerySchema = z.object({
    status: z.enum(['active', 'delivered', 'all']).default('active'),
    page: z.coerce.number().int().min(1).default(1),
    limit: z.coerce.number().int().min(1).max(100).default(50),
});
// ─── Operator/punkt yetkazish bo'limi: barcha delivery buyurtmalari ──
export const pointDeliveryQuerySchema = z.object({
    status: z.enum(['active', 'delivered', 'all']).default('active'),
});
// ─── Kuryer GPS lokatsiyasini yangilash ───────────────────────────
export const courierLocationSchema = z.object({
    lat: z.number().min(-90).max(90),
    lng: z.number().min(-180).max(180),
});
// ─── Kuryer hisobi yaratish (EGASI / punkt operatori) ─────────────
export const createCourierSchema = z.object({
    username: z
        .string()
        .min(3, 'Login kamida 3 ta belgi')
        .max(50)
        .regex(/^[a-zA-Z0-9_]+$/, 'Faqat harf, raqam, _'),
    password: z.string().min(6, 'Parol kamida 6 ta belgi').max(100),
    name: z.string().min(1, 'Ism kerak').max(120),
    /**
     * Qaysi punktga biriktirilgan. EGASI uchun MAJBURIY (punkt tanlaydi);
     * PICKUP_OPERATOR uchun ixtiyoriy — o'z punkti avtomat ishlatiladi.
     */
    pickupPointId: uuidSchema.optional(),
});
// ─── Buyurtmani kuryerga biriktirish (punkt operatori / EGASI) ────
export const assignCourierSchema = z.object({
    courierId: uuidSchema,
});
// ─── Yetkazish/topshirish tasdiqlash kodi (proof of delivery) ─────
// Buyer Telegram'da buyurtma raqamini oladi — kuryer/operator topshirishda
// raqamning OXIRGI 4 belgisini kiritadi (server solishtiradi). Bu "istalgan
// joyda Yetkazdim bosish" va noto'g'ri odamga topshirishdan himoya (audit high).
export const handoverCodeSchema = z.object({
    code: z.string().trim().min(2, 'Kod kamida 2 belgi').max(24, 'Kod juda uzun'),
});
// ─── Yetkazib bo'lmadi (FAILED) — sabab bilan ─────────────────────
// Kuryer yetkaza olmasa: sabab yoziladi, buyurtma biriktirilmaganlar
// ro'yxatiga qaytadi (operator/EGASI qayta biriktiradi yoki bekor qiladi).
export const deliveryFailSchema = z.object({
    reason: z.string().trim().min(3, 'Sabab kamida 3 belgi').max(200),
});
// ─── Kunlik yetkazish hisoboti (EGASI) ────────────────────────────
export const courierReportQuerySchema = z.object({
    date: z.string().optional(), // ISO sana (YYYY-MM-DD), default bugun
});
//# sourceMappingURL=marketplace-courier.schema.js.map